import { type Language, useLanguage } from '@fliisi/i18n'
import type { GetProps } from 'tamagui'
import { ButtonGroup } from './ButtonGroup'

const LANGUAGE_OPTIONS = [
  { label: 'FI', value: 'fi' },
  { label: 'EN', value: 'en' },
]

type LanguageSwitcherProps = Omit<GetProps<typeof ButtonGroup>, 'options' | 'value' | 'onValueChange'>

export function LanguageSwitcher(props: LanguageSwitcherProps) {
  const { language, setLanguage } = useLanguage()
  return (
    <ButtonGroup
      alignSelf="flex-start"
      {...props}
      options={LANGUAGE_OPTIONS}
      value={language}
      onValueChange={(v) => setLanguage(v as Language)}
    />
  )
}
